import { render, staticRenderFns } from "./FontMechanism.vue?vue&type=template&id=0bcaa93c&"
import script from "./FontMechanism.vue?vue&type=script&lang=js&"
export * from "./FontMechanism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports